import 'css-chunksrc/client/scenes/documentCreation/form/styles.scss';export default {
  "form": "_form_3nwv2_1",
  "folderSelection": "_folderSelection_3nwv2_7",
  "name": "_name_3nwv2_14"
};